<template>
  <section class="profile-section z-30">
    <h1>
      <span class="light">SOFTWARE</span><br />
      <span class="dark">ENGINEER</span>
    </h1>
    <p class="description">Passionate about creating intuitive and engaging user experiences. Specialized in transforming ideas into beautifully crafted products.</p>
    <div class="stats">
      <div class="stat"><span class="number">3+</span> YEARS OF<br /> EXPERIENCE</div>
      <div class="stat"><span class="number">18+</span> PROJECTS<br /> COMPLETED</div>
      <div class="stat"><span class="number">2+</span> WORLDWIDE<br /> CLIENTS</div>
    </div>
    <div class="tech-stack">
      <div class="tech-card orange">
        <span class="tech-label">MERN Stack</span>
        <span class="tech-detail">Express | MongoDB | REACT | Vue</span>
      </div>
      <div class="tech-card green">
        <span class="tech-label">AI/ML,</span>
        <span class="tech-detail">OpenAI | AI Automation | Deep Learning | NLP | Computer Vision</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProfileSection'
}
</script>

<style scoped>
.profile-section {
  background-color: #0f0d0d;
  padding: 40px;
  text-align: center;
  color: white;
  max-width: 800px;
}

h1 {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 20px;
  line-height: 1;
  margin-left: 0px;
}

.light {
  color: white;
}

.dark {
  color: #3d3d3d;
}

.description {
  font-size: 1rem;
  color: #bbb;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
  font-size: 1.2rem;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.6rem;
  color: #454249;
}

.number {
  font-weight: bold;
  color: #9d6cf0;
  font-size: 1.5rem;
  margin-bottom: 5px;
}

.tech-stack {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.tech-card {
  padding: 20px;
  border-radius: 10px;
  width: 250px;
  text-align: left;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.orange {
  background-color: #f28c38;
}

.green {
  background-color: #a2e94a;
}

.tech-label {
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
}

.tech-detail {
  display: block;
  font-size: 1rem;
  color: #fff;
}


@media screen and (max-width: 1000px) {
.tech-stack {
  flex-direction: column;
  width: 100%; /* Ensures the container takes full width */
  text-align: center;
}

.tech-card {
  width: 100%; /* Makes each card span the full width of the parent */
  box-sizing: border-box; /* Includes padding and border in the width calculation */
  padding: 10px; /* Optional: Adds some internal spacing */
  text-align: center;
}


}
</style>